import { ResponsiveStyleValue } from '@wrisk/styled-system'
import React, { FunctionComponent } from 'react'
import { useTheme } from 'styled-components'

import { WriskTheme } from '../../themes'

export interface ResponsivePictureProps {
  className?: string
  sources: ResponsiveStyleValue<string>
  alt?: string
  width?: string
  height?: string
}

export const ResponsivePicture: FunctionComponent<ResponsivePictureProps> = ({
  className,
  sources,
  width,
  height,
  alt = '',
}) => {
  const theme = useTheme() as WriskTheme

  const breakpoints = theme.breakpoints

  if (typeof sources === 'string') {
    return <img src={sources} alt={alt} className={className} />
  }

  if (!sources.length) {
    return null
  }

  const [mobileSrc, ...sourceSets] = sources.filter((src): src is string => Boolean(src))

  return (
    <picture>
      {sourceSets
        .map((source, index) => {
          const breakpoint = breakpoints[index]

          return breakpoint ? (
            <source key={source} srcSet={source} media={`(min-width: ${breakpoint})`} />
          ) : null
        })
        .toReversed()}
      <img
        width={width}
        height={height}
        src={mobileSrc}
        alt={alt}
        className={className}
      />
    </picture>
  )
}
